import { atom } from 'jotai';

export const archSearchKeyword = atom<{
  techstack: string[];
  category: string;
  company: string;
}>({
  techstack: [],
  category: '',
  company: '',
});

export const archSelectedBox = atom('popular');
